export default "__VITE_PUBLIC_ASSET__11a9a670__"